package ai.jessie.web.pages.registration

import ai.jessie.web.theme.ButtonVariant
import ai.jessie.web.theme.entryFrame
import ai.jessie.web.theme.linkButton
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun invalidPage() {
    entryFrame("Bestätigung fehlgeschlagen", authenticationRequired = true) {
        P { Text("Die Bestätigung ist ungültig oder abgelaufen. Starte die Registrierung erneut.") }
        P {
            Text("Falls du eine Einladung erhalten hast, öffne erneut den Link aus der Einladung.")
        }
        P {
            linkButton(
                "Registrierung neu starten",
                "/api/v1/registration/start",
                ButtonVariant.PRIMARY,
            )
        }
    }
}
